const Menu = () => {
  return (
    <header className="header clearfix">
      <a href="https://www.teledec.fr">
        <img src="https://www.teledec.fr/assets/images/LOGO_C.png" alt="" />
      </a>
    </header>
  );
};

export default Menu;
